import React, { useEffect, useState } from "react";
import axios from "axios";
import GroupApi from "../../api/GroupApi";
import TypeApi from "../../api/TypeApi";
import SourceApi from "../../api/SourceApi";
import { showError, showSuccess } from "../../utils/toastUtils";

function AddDetails({ onAdded }) {
  const [typeList, setTypeList] = useState([]);
  const [GroupList, setGroupList] = useState([]);

  const [type, setType] = useState("");
  const [group, setGroup] = useState("");

  const [source, setSource] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchTypeData();
    fetchGroups();
  }, []);

  const fetchTypeData = async () => {
    const res = await TypeApi.list();

    if (res.code === 200) {
      setTypeList(res.data);
    }
  };

  const fetchGroups = async () => {
    const res = await GroupApi.list();

    if (res.code === 200) {
      setGroupList(res.data);
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!type && !group) {
    showError("At least one of Type, Group is required");
    return;
  }

   if (!source) {
    showError("source is required");
    return;
  }

  try {
    const payload = { type, group, source };

    const res = await SourceApi.add(payload);

    if (res.code === 200) {
      showSuccess(res.message); 
      document.getElementById("closeOffcanvasBtn").click();

      setType("");
      setSource("");
      setGroup("");
      setErrors({});
      if (onAdded) onAdded();
    } else {
      showError(res.message);
    }
  } catch (err) {
    showError(err.message);
  }
};


  return (
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Add Lead Source</h4>
          <button type="button" className="btn-close" data-bs-dismiss="modal" id="closeOffcanvasBtn" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body container">
            <div className="mb-3">
              <label className="form-label">Lead Type</label>
              <select className="form-select" value={type} onChange={(e) => setType(e.target.value)} >
                <option value="">-- Select Type --</option>
                {typeList.map((t) => (
                  <option key={t._id} value={t._id}>
                    {t.type}
                  </option>
                ))}
              </select>
              {errors.type && (
                <span className="text text-danger">{errors.type}</span>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Lead Group</label>
              <select
                className="form-select" value={group} onChange={(e) => setGroup(e.target.value)} >
                <option value="">-- Select Group --</option>
                {GroupList.map((g) => (
                  <option key={g._id} value={g._id}>
                    {g.group}
                  </option>
                ))}
              </select>
              {errors.group && (
                <span className="text text-danger">{errors.group}</span>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Source</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter source"
                value={source}
                onChange={(e) => setSource(e.target.value)}
              />
              {errors.source && (
                <span className="text text-danger">{errors.source}</span>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Add
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
export default AddDetails;
